import { Injectable } from '@angular/core';
import { CUSTOMAPIService } from 'app/custom-api.service';
import { ToastrService } from 'ngx-toastr';
import { FrameworkTreeService } from './framework-tree.service';
import { UtilsService } from './utils.service';
import { LabelType } from 'app/API.service';

@Injectable()
export class DefaultTagsService {
  frameworksWithTags: string[] = ['SHC'];

  constructor(
    private frameworkTreeService: FrameworkTreeService,
    private toastrService: ToastrService,
    private customApi: CUSTOMAPIService
  ) {}

  static getFrameworksWithTags(): string[] {
    let frameworksWithTags = null;
    switch (true) {
      case UtilsService.isSHC:
        frameworksWithTags = ['SHC'];
        break;
    }
    return frameworksWithTags;
  }

  static getQuestionsFromTree(node: any): any[] {
    if (node.children) {
      const questions = node.children.map(childNode => DefaultTagsService.getQuestionsFromTree(childNode));
      return questions.flat();
    } else if (node.questions) {
      return node.questions.map(question => {
        question.controlName = node.name;
        return question;
      });
    }
  }

  // this function creates general tags after root entity is created according to the relevant framework
  async createDefaultTagsForRootEntity(entityId: string): Promise<void> {
    const frameworksWithTagsArray: string[] = DefaultTagsService.getFrameworksWithTags();
    if (!frameworksWithTagsArray) {
      // No frameworks with tags found
      return;
    }

    try {
      const globalTags = await this.buildTagsFromCSVs(frameworksWithTagsArray);
      const promises = globalTags.map(tag => {
        const globalObj = {
          name: tag,
          entityId,
          domain: window.location.hostname,
          targetId: '_Global',
          targetName: '_Global',
          assessmentFrameworkKey: '_Global',
          referenceId: '_Global',
          type: LabelType.GENERAL,
          questionRefId: '_Global',
          parentTagId: null,
        };
        // console.log('Creating tag:', globalObj);
        return this.customApi.CreateTags(globalObj);
      });
      await Promise.all(promises);
    } catch (error) {
      console.error('Error - createDefaultTagsForRootEntity:', error);
      // this.toastrService.error('Failed to create default tags for root entity', 'Error');
    }
  }

  // build tags list from CSV's files
  async buildTagsFromCSVs(frameworksWithTagsArray: string[]): Promise<string[]> {
    try {
      const promises = frameworksWithTagsArray.map(frameworkKey =>
        this.frameworkTreeService.getFrameworkFromS3(frameworkKey)
      );

      const csvTrees = await Promise.all(promises);
      const tagsObj = {};
      csvTrees.forEach(csvTree => {
        csvTree.forEach(row => {
          const defaultTags = row.defaultTags ? row.defaultTags.split(',').map(tag => tag.trim()) : null;
          if (defaultTags && defaultTags.length > 0) {
            defaultTags.forEach(tag => {
              if (!tagsObj[tag]) {
                tagsObj[tag] = true;
              }
            });
          }
        });
      });
      // console.log('Tags: ', Object.keys(tagsObj));
      return Object.keys(tagsObj);
    } catch (error) {
      console.error('Error - buildTagsFromCSVs:', error);
      return;
    }
  }

  checkIfDefaultTagsExistForAssessment(frameworkKey: string): boolean {
    const frameworksWithTagsArray: string[] = DefaultTagsService.getFrameworksWithTags();
    return frameworksWithTagsArray && frameworksWithTagsArray.includes(frameworkKey);
  }

  async createDefaultTagsForAssessment(entityId: string, assessmentId: string, frameworkKey: string): Promise<void> {
    if (!entityId || !assessmentId || !frameworkKey) {
      console.error('Entity ID or Assessment ID or Framework Key is missing');
      return;
    }

    try {
      const framework: any = { key: frameworkKey };
      const tree = await this.frameworkTreeService.getAssessmentTreeFromS3(assessmentId, framework);
      // console.log('Tree:', tree);

      const promises = [];
      const assessmentFrameworkKey = `${assessmentId}#${frameworkKey}`;
      const questionList = DefaultTagsService.getQuestionsFromTree(tree);

      questionList.forEach(question => {
        if (question.defaultTags && question.defaultTags.length > 0) {
          const targetId = `${assessmentId}#${question.id}`;
          question.defaultTags.forEach(tagName => {
            const questionTag = {
              name: tagName,
              entityId,
              domain: window.location.hostname,
              targetId,
              assessmentFrameworkKey,
              referenceId: question.id,
              questionRefId: question.id,
              type: LabelType.GENERAL,
              parentTagId: null,
            };

            // console.log('Creating tag for question:', questionTag);
            promises.push(this.customApi.CreateTags(questionTag));
          });
        } else {
          console.log('No tags found for this question: ', question.id);
          return;
        }
      });

      // await Promise.all(promises);
    } catch (error) {
      console.error('Error - createDefaultTagsForAssessment:', error);
      // this.toastrService.error('Failed to create default tags for assessment', 'Error');
    }
  }
}
